module.exports = __webpack_public_path__ + "img/hw.af3e95be.jpg";